module.exports = __webpack_public_path__ + "static/img/menu-up-dark.f6046dc.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/menu-up-dark.png
// module id = NFRa
// module chunks = 1